export const MONTH_YEAR = 'MMM, YYYY';
export const DEFAULT_SERVICE_ID = '1';
export const STATISTIC_DATA_GLOBAL_NAME = 'All';
export const CYRILLIC_PATTERN = /^[\u0400-\u04FF]+$/;

export const SATISFACTION_LEVELS = {
	veryPoor: {
		min: 1,
		max: 39,
		type: 'very_poor',
	},
	poor: {
		min: 40,
		max: 49,
		type: 'poor',
	},
	ok: {
		min: 50,
		max: 59,
		type: 'ok',
	},
	good: {
		min: 60,
		max: 69,
		type: 'good',
	},
	great: {
		min: 70,
		max: 100,
		type: 'great',
	},
	all: {
		min: 0,
		max: 100,
		type: 'all',
	},
};

export const TREND_LIST = {
	show: 6,
	add: 3,
};

export const PERSONA_ITEMS_SHOW_SETTINGS = {
	show: 3,
	add: 3,
};

export const COMMENTS_RATING_LEVELS = {
	negative: {
		min: 1,
		max: 3,
	},
	neutral: {
		min: 4,
		max: 5,
	},
	positive: {
		min: 6,
		max: 7,
	},
};

export const LINE_TENSION = 0;

export const GRAPH_AXYS = {
	min: 0,
	max: 100,
};

export const RED_COLOR_STRING = '230, 20, 0';
export const YELLOW_COLOR_STRING = '255, 209, 71';
export const GREEN_COLOR_STRING = '170, 223, 60';
export const ALPHA_COLOR_PARAMS = [0.4, 0.25, 0.1];

export const DEFAULT_REGION = 'GLOBAL';

export const DOTS = 'dots';
export const DEFAULT_PAGE_NUMBER = 1;
export const COMMENTS_PER_PAGE_OPTIONS = [10, 25, 50, 100];
export const SERVICES_PER_PAGE_OPTIONS = [6, 9, 15];
export const SURVEYS_PER_PAGE_OPTIONS = [6, 12, 24];

export const PERSONA_WORK_STYLE_RATING_LEVELS = {
	extreme: {
		title: 'extreme',
		min: 90,
	},
	high: {
		title: 'high',
		min: 60,
	},
	moderate: {
		title: 'moderate',
		min: 30,
	},
	somewhat: {
		title: 'somewhat',
		min: 10,
	},
	notVery: {
		title: 'not_very',
		min: 0,
	},
};

export const PERSONA_NAMES = [
	'ramon',
	'eileen',
	'fred',
	'dolores',
	'jeremiah',
	'serenity',
	'enrique',
	'claudia',
	'armando',
	'dora',
	'tom',
	'ana',
	'alex',
	'vickie',
	'danny',
	'tanya',
	'craig',
	'georgia',
	'philip',
	'jennie',
	'fernando',
	'amelia',
	'larry',
	'leah',
	'joe',
	'miriam',
	'carter',
	'laurie',
	'ivan',
	'alyssa',
	'ruben',
	'tiffany',
	'andrew',
	'charlene',
	'thomas',
	'debra',
	'dwight',
	'dianne',
	'duane',
	'violet',
	'roberto',
	'ruby',
	'jesus',
	'addison',
	'rodney',
	'tammy',
	'jordan',
	'jessica',
	'shawn',
	'tammy',
	'willie',
	'linda',
	'hunter',
	'leona',
	'roger',
	'olivia',
	'byron',
	'valerie',
	'adrian',
	'annie',
	'franklin',
	'kitty',
	'gabe',
	'noelle',
	'francis',
	'georgia',
	'ethan',
	'sarah',
	'danny',
	'dana',
	'james',
	'lucille',
	'jose',
	'juanita',
	'mathew',
	'carole',
	'harvey',
	'kelly',
	'nora',
];
